<p>If you're not redirected please <a [href]="url">click here</a></p>
